module.exports = __webpack_public_path__ + "media/components/riskregister/icon-vectors/operations-281ffe48fc67eb63bf800db7b454db99.png";